// export const isLoading = (state) => state.auth.loading;
// export const isError = (state) => state.auth.error;
// export const isAuthenticated = (state) => state.auth.isAuthenticated;
// export const isMessage = (state) => state.auth.message;
// export const isData = (state) => state.auth.data;
// export const isRole = (state) => state.auth.role;
// export const isRoleID = (state) => state.auth.role_id;
// export const isPermission = (state) => state.auth.permissions;

// ../redux/selectors/authSelector.js
import { createSelector } from "reselect";

export const isLoading = (state) => state.auth.loading;
export const isError = (state) => state.auth.error;
export const isAuthenticated = (state) => state.auth.isAuthenticated;
export const isMessage = (state) => state.auth.message;
export const isData = (state) => state.auth.data;
export const isRole = (state) => state.auth.role;
export const isRoleID = (state) => state.auth.role_id;
export const isPermission = (state) => state.auth.permissions;

/**
 * One-shot, memoized selector for the route gate.
 * Derives a 'status' from loading/isAuthenticated to avoid extra fields in your slice.
 */
export const selectAuthGate = createSelector(
  (state) => state.auth,
  (auth) => {
    const user = auth?.data?.user || {};
    const school = user?.school_id || {};

    const status = auth?.loading
      ? "checking"
      : auth?.isAuthenticated
      ? "authenticated"
      : "unauthenticated";

    return {
      status,                                   // 'checking' | 'authenticated' | 'unauthenticated'
      isAuthenticated: !!auth?.isAuthenticated, // boolean
      role: auth?.role ?? user?.role ?? null,   // prefer slice.role, fallback to user.role
      roleType: user?.role_type ?? null,
      isProfileCompleted: !!user?.is_profile_completed,
      isApproved: !!user?.is_approved,
      isVerified: !!school?.is_school_verified,
      school: Object.keys(school).length ? school : null,
    };
  }
);
